import React from 'react';
import { Wifi, WifiOff, Clock, ChevronRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { formatRelativeTime } from './activityUtils';
import { LocationText } from './LocationText';

export const OnlineUsersTab = ({ onlineUsers, onSelectUser }) => (
  <Card className="bg-gray-900 border-gray-800" data-testid="online-users-card">
    <CardHeader>
      <CardTitle className="text-white flex items-center gap-2">
        <div className="w-3 h-3 rounded-full bg-green-500 animate-pulse" />
        Usuarios Conectados
      </CardTitle>
      <CardDescription className="text-gray-500">
        Usuarios activos en los ultimos 5 minutos
      </CardDescription>
    </CardHeader>
    <CardContent>
      {onlineUsers.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 text-gray-500">
          <WifiOff size={40} className="mb-3 opacity-50" />
          <p>No hay usuarios conectados ahora</p>
        </div>
      ) : (
        <div className="space-y-3">
          {onlineUsers.map((u) => (
            <div
              key={u.id}
              className="flex items-center justify-between p-4 rounded-xl bg-gray-800/50 border border-gray-700/50 hover:bg-gray-800 transition-colors cursor-pointer"
              onClick={() => onSelectUser(u.id)}
              data-testid={`online-user-${u.id}`}
            >
              <div className="flex items-center gap-4">
                <div className="relative">
                  <div className="w-11 h-11 rounded-full bg-gradient-to-br from-green-500/30 to-emerald-600/30 border border-green-500/40 flex items-center justify-center">
                    <span className="text-white font-bold text-sm">
                      {u.name?.charAt(0)?.toUpperCase() || u.email?.charAt(0)?.toUpperCase()}
                    </span>
                  </div>
                  <div className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full bg-green-500 border-2 border-gray-900" />
                </div>
                <div>
                  <p className="text-white font-medium">{u.name || 'Sin nombre'}</p>
                  <p className="text-gray-500 text-xs">{u.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-6">
                <LocationText location={u.last_location} />
                <div className="text-right">
                  <p className="text-gray-400 text-xs flex items-center gap-1">
                    <Clock size={12} />
                    {formatRelativeTime(u.last_active)}
                  </p>
                </div>
                <ChevronRight size={18} className="text-gray-600" />
              </div>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);
